import RestService from "./restService";
import { SUBSISTENCE } from "../../url/index";

const singleton = Symbol();
const singletonEnforcer = Symbol();

/**
 *
 */
class SubsistenceService extends RestService {
  constructor(enforcer) {
    super(SUBSISTENCE);
    if (enforcer !== singletonEnforcer) throw new Error("Cannot construct SUBSISTENCE RestService more than one");
  }

  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new SubsistenceService(singletonEnforcer);
    }
    return this[singleton];
  }
}

export default SubsistenceService;
